import {
  isBrowserSupported,
  renderLoadError,
  renderUnsupportedBrowser,
} from '@/lib/browserSupport';

// "Gate" de compatibilidade: rodamos a checagem ANTES de importar o app.
// O import dinâmico garante que as dependências pesadas (React 19, Amplify e
// demais chunks de vendor) só sejam avaliadas em navegadores compatíveis —
// navegadores antigos, que quebrariam na inicialização desses módulos
// ("this.o.at is not a function"), nunca chegam a carregá-los.
//
// Mantenha este arquivo livre de sintaxe ES2020+ (`?.`, `??`): ele precisa
// ser analisável por navegadores antigos para que a tela de aviso apareça.
if (isBrowserSupported()) {
  // Se o chunk do app falhar ao carregar (deploy desatualizado, falha de
  // rede), registramos o erro e exibimos uma tela de erro com botão de
  // recarregar — sem isso a splash inline giraria para sempre.
  void import('@/bootstrap').catch((error: unknown) => {
    console.error('Falha ao inicializar o aplicativo:', error);
    renderLoadError();
  });
} else {
  renderUnsupportedBrowser();
}
